const API_BASE = "/api";

export async function login(username: string, password: string) {
  const res = await fetch(`${API_BASE}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) throw new Error("Login failed");
  return res.json();
}

export async function fetchCatalogs(token: string, apiUrl = "") {
  const res = await fetch(`${API_BASE}/catalogs`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Failed to fetch catalogs");
  return res.json();
}

export async function fetchFile(token: string, filePath: string) {
  const res = await fetch(`${API_BASE}/files/${filePath}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Failed to fetch file");
  return res.text();
}

